export const PATH = {
  'DEFAULT': '',
  'HOME': '/',
  'ERROR': '/error',
  'SEARCH': '/search',
  'FAVORITES': '/favorites',
  'LIVE': '/live',
  'CATEGORIES': '/categories',
  'CHANNEL_OWNERS': '/channel-partners',
  'CTV': '/ctv',
  'CONTENT_SET': '/contentset',
  'MOVIES': '/movies',
  'HASHTAG': '/hashtag',
  'MOVIE': '/movie',
  'PLAY': '/play',
  'SETTINGS': '/settings',
  'TERMS_OF_USE': '/terms-of-use',
  'INDUSTRY': '/industry',
  'VERIFY': '/verify',
  'ABOUT': '/about',
  'GEOBLOCK': '/geoblock',
  'TVSHOWS': '/tvshows',
  'TVSHOW': '/tvshow',
  // path-to-regexp v8 (universal-router 10) dropped unnamed groups; `/*path` is the wildcard now
  'NOT_FOUND_404': '/*path',
  '404': '/404',

  // creators
  'CREATOR': '/creator',
  'CREATORS': '/creators',

  // static
  'STATIC': '/static',
  'STATIC_PRIVACY': '/static/privacy',
  'STATIC_SUPPORT': '/static/support',
  'STATIC_INFRINGEMENT_POLICY': '/static/infringementpolicy',
  'SUPPORT': '/support',
  'INFRINGEMENT_POLICY': '/infringementpolicy',

  //privacy
  'PRIVACY': '/privacy',
  'PRIVACY_SENSITIVE': '/privacy/sensitive',
  'PRIVACY_YOUR_PRIVACY_CHOICES': '/privacy/your-privacy-choices',
  'PRIVACY_MYDATA': '/privacy/mydata',
  'SENSITIVE': '/sensitive',
  'YOUR_PRIVACY_CHOICES': '/your-privacy-choices',
  'MY_DATA': '/mydata',

  // confirmation
  'CONFIRMED': '/confirmed',
  'EMAIL_CAPTURE_CONFIRM': '/email-capture/confirm',

  // auth
  'FORGOT_PASSWORD': '/forgot-password',
  'SIGN_IN': '/sign-in',
  'SIGN_UP': '/sign-up',
  'RESET': '/reset',
}

export const SEGMENT = {
  REGION: 'regionTitleId',
  CATEGORY: 'categoryTitleId',
  CHANNEL: 'channelTitleId',
} as const

export const RESERVED_NAME = {
  ALL: 'all',
  MY_LIST: 'my-list',
}

export type ReservedNameType =
  (typeof RESERVED_NAME)[keyof typeof RESERVED_NAME]

export const PARAM = {
  CATEGORY: 'category',
  LANGUAGE: 'language',
  GENRE: 'genre',
  REGION: 'region',
  CHANNEL: 'channel',
}

export const ROUTE_NAME = {
  MOVIES_CATEGORIES: `${PATH.MOVIES}${PATH.CATEGORIES}`,
  MOVIE: PATH.MOVIE,
  TVSHOWS_CATEGORIES: `${PATH.TVSHOWS}${PATH.CATEGORIES}`,
  TVSHOW: PATH.TVSHOW,
  LIVE_CATEGORIES: `${PATH.LIVE}${PATH.CATEGORIES}`,
  HOME: '/home',
  CONTENT_SET: PATH.CONTENT_SET,
  FAVORITES: PATH.FAVORITES,
  SETTINGS: PATH.SETTINGS,
}

export const UTM_PARAM = {
  CAMPAIGN: 'utm_campaign',
}
